'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InterlibraryLoans;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function InterlibraryLoans(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-interlibraryloans ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: color, fillRule: 'nonzero' },
      _react2.default.createElement('path', { d: 'M16 8a7.76 7.76 0 0 1-1.08 4A8.084 8.084 0 0 1 12 14.92 7.76 7.76 0 0 1 8 16a7.76 7.76 0 0 1-4-1.08A8.084 8.084 0 0 1 1.08 12 7.76 7.76 0 0 1 0 8c0-1.44.36-2.774 1.08-4A8.084 8.084 0 0 1 4 1.08 7.76 7.76 0 0 1 8 0c1.44 0 2.773.36 4 1.08A8.084 8.084 0 0 1 14.919 4 7.76 7.76 0 0 1 16 8zM1.549 8c0 1.161.29 2.237.87 3.226a6.504 6.504 0 0 0 2.355 2.355 6.26 6.26 0 0 0 3.227.87 6.26 6.26 0 0 0 3.225-.87 6.504 6.504 0 0 0 2.355-2.355A6.26 6.26 0 0 0 14.45 8a6.26 6.26 0 0 0-.87-3.226 6.504 6.504 0 0 0-2.355-2.355A6.26 6.26 0 0 0 8 1.55a6.26 6.26 0 0 0-3.226.87 6.504 6.504 0 0 0-2.355 2.355A6.26 6.26 0 0 0 1.55 8z' }),
      _react2.default.createElement('path', { d: 'M5.424 7.145v.734a.386.386 0 0 1-.103.272.332.332 0 0 1-.253.112.332.332 0 0 1-.252-.112L3.539 6.777a.384.384 0 0 1-.104-.271c0-.107.035-.197.104-.271L4.816 4.86a.332.332 0 0 1 .252-.111c.1 0 .183.037.253.111.068.074.105.171.103.272v.734h4.483c.049 0 .091.019.126.056a.192.192 0 0 1 .052.136v.894a.191.191 0 0 1-.052.136.166.166 0 0 1-.127.056H5.424zm5.091 3.27H6.033a.166.166 0 0 1-.126-.056.192.192 0 0 1-.052-.136V9.33c0-.054.018-.098.052-.136a.166.166 0 0 1 .127-.056h4.481v-.734c0-.107.035-.197.104-.272a.332.332 0 0 1 .253-.111.33.33 0 0 1 .252.111l1.277 1.374c.069.073.106.17.104.271a.384.384 0 0 1-.104.271l-1.277 1.374a.332.332 0 0 1-.252.112.332.332 0 0 1-.253-.112.384.384 0 0 1-.104-.272v-.734z' })
    )
  );
}

InterlibraryLoans.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/InterlibraryLoans/InterlibraryLoans.js
// module id = 1213
// module chunks = 1